import React from 'react';

type CloseIconProps = {
  onClick: () => void;
};

export const CloseIcon: React.FC<CloseIconProps> = ({
  onClick,
}: CloseIconProps): JSX.Element => {
  return (
    <svg
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="close-icon"
      onClick={onClick}
    >
      <rect
        x="17.6775"
        y="16.7634"
        width="2"
        height="16"
        rx="1"
        transform="rotate(135 17.6775 16.7634)"
        fill="#394577"
      />
      <rect
        x="6.36401"
        y="18.1775"
        width="2"
        height="16"
        rx="1"
        transform="rotate(-135 6.36401 18.1775)"
        fill="#394577"
      />
    </svg>
  );
};
